import * as React from 'react'
import { animated, useSpring, config } from '@react-spring/web'
import { darken } from 'polished'
import { Side } from 'src/editor/types'
import { IconProps } from './types'

interface NavigationProps extends Omit<IconProps, 'color'> {
  color: string
  side: Side
}

const points: { [key in Side]: string } = {
  front: '3,18 3,6 12,10 12,22',
  top: '3,6 12,2 21,6 12,10',
  right: '12,10 21,6 21,18 12,22',
  bottom: '3,18 12,14 21,18 12,22',
  left: '12,2 3,6 3,18 12,14',
  back: '21,18 21,6 12,2 12,14'
}

export const NavigationIcon: React.SFC<NavigationProps> = ({
  title = 'Enclosure',
  color,
  side = 'front'
}) => {
  const secondColor = darken(0.2, color)
  const fill = color
  return (
    <svg
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <g stroke={secondColor} strokeLinecap="round" strokeWidth="1">
        <animated.polygon {...{ fill, points: points[side] }} />
        <polygon fill="none" points="21,18 12,22 3,18 3,6 12,2 21,6 " />
        <line fill="none" x1="12" x2="12" y1="10" y2="22" />
        <polyline fill="none" points="3,6 12,10 21,6 " />
      </g>
    </svg>
  )
}

export const LoginIcon = ({
  color = 'rgba(255,255,255,1)',
  title = 'login'
}) => {
  return (
    <svg
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <g
        fill={color}
        stroke={color}
        strokeLinecap="square"
        strokeWidth="1"
        transform="translate(0.5 0.5)"
      >
        <line fill="none" strokeLinecap="butt" x1="1" x2="14" y1="12" y2="12" />
        <polyline fill="none" points="10 16 14 12 10 8" />
        <polyline
          fill="none"
          points="2 17 2 22 22 22 22 2 2 2 2 7"
          stroke={color}
        />
      </g>
    </svg>
  )
}

export const ProjectsIcon = ({ color = 'var(--color)', ...props }) => {
  const title = props.title || 'projects'

  return (
    <svg
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <g
        fill={color}
        stroke={color}
        strokeLinecap="square"
        strokeWidth="1"
        transform="translate(0.5 0.5)"
      >
        <rect height="4" width="12" fill="none" x="10" y="2" />
        <rect height="4" width="12" fill="none" x="10" y="10" />
        <rect height="4" width="12" fill="none" x="10" y="18" />
        <rect height="4" width="4" fill="none" stroke={color} x="2" y="2" />
        <rect height="4" width="4" fill="none" stroke={color} x="2" y="10" />
        <rect height="4" width="4" fill="none" stroke={color} x="2" y="18" />
      </g>
    </svg>
  )
}

export const CubeIcon = ({ color = 'var(--color)', ...props }) => {
  const title = props.title || 'app'
  return (
    <svg
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <g
        fill={color}
        stroke={color}
        strokeLinecap="square"
        strokeWidth="1"
        transform="translate(0.5 0.5)"
      >
        <polyline fill="none" points="3,6 12,10 21,6 " strokeLinecap="butt" />
        <line
          fill="none"
          strokeLinecap="butt"
          x1="12"
          x2="12"
          y1="10"
          y2="22"
        />
        <polygon
          fill="none"
          points="21,18 12,22 3,18 3,6 12,2 21,6 "
          stroke={color}
        />
      </g>
    </svg>
  )
}
